<template>
  <div class="flex flex-col gap-1">
    <label class="font-semibold">{{ label }}</label>

    <!-- SIMPLE -->
    <Multiselect
      v-if="mode === 'simple'"
      v-model="selectedValue"
      :options="combinedOptions"
      :multiple="false"
      :trackBy="'value'"
      :valueProp="'value'"
      :label="'label'"
      @update:modelValue="emitValue"
      :canClear="false"
    />

    <!-- RANGE -->
    <div v-else class="flex gap-2">
      <Multiselect
        v-model="rangeA"
        :options="combinedOptions"
        :multiple="false"
        :trackBy="'value'"
        :valueProp="'value'"
        :label="'label'"
        @change="emitRangeValue"
        :canClear="false"
      />
      <Multiselect
        v-model="rangeB"
        :options="combinedOptions"
        :multiple="false"
        :trackBy="'value'"
        :valueProp="'value'"
        :label="'label'"
        @change="emitRangeValue"
        :canClear="false"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import Multiselect from '@vueform/multiselect';
import '@vueform/multiselect/themes/tailwind.css';
import api from '@/api';
import { useFilterStore } from '@/store/filterStore.js';

const props = defineProps({
  name: { type: String, required: true },
  label: { type: String, required: true },
  placeholder: { type: String, default: '' },
  property: { type: Number, required: true },
  dataType: { type: Number, required: true },
  mode: {
    type: String,
    default: 'simple', // or "range"
    validator: val => ['simple', 'range'].includes(val),
  },
});

const filterStore = useFilterStore();
const selectedValue = ref(null);
const rangeA = ref(null);
const rangeB = ref(null);
const currentOptions = ref([]);

const combinedOptions = computed(() =>
  currentOptions.value.map(item => ({
    value: item.id,
    label: item.name,
  })),
);

const fetchAllOptions = async () => {
  const allResults = [];
  let page = 1;
  let hasNext = true;

  try {
    while (hasNext) {
      const response = await api.get(
        `attributes/select_values/?property=${props.property}&page=${page}`,
      );
      const { results, next } = response.data;
      allResults.push(...results);
      hasNext = !!next;
      page += 1;
    }
    currentOptions.value = allResults;
  } catch (error) {
    console.error('Error fetching options:', error);
  }
};

const emitValue = () => {
  const raw = selectedValue.value;

  if (!raw) {
    filterStore.removeFilterByProperty(props.property);
    return;
  }

  const id = typeof raw === 'object' ? raw.value : raw;
  if (!id) return;

  filterStore.updateFilter({
    type: 'select',
    property: props.property,
    value: Number(id),
  });

  // ❗ Правильный вызов с property_id
  filterStore.fetchDynamicCount({
    property: props.property,
    data_type: 'select_values',
    property_id: props.property,
  });
};

const emitRangeValue = part => {
  if (rangeA.value && rangeB.value) {
    filterStore.updateFilter({
      type: 'range',
      property: props.property,
      value: [rangeA.value, rangeB.value],
    });
    filterStore.fetchDynamicCount();
  }
};

onMounted(fetchAllOptions);
</script>

<style scoped>
/* кастомные стили при необходимости */
</style>
